import React, { useCallback } from 'react'
import { Form, Formik, FormikConfig, FormikProps, FormikValues } from 'formik'
import { FormModalScreen } from 'components/FormModal'
import { OrganizationFormData } from 'organization/types'

export type ButtonProps = {
  caption: string
  onClick: (...args: any[]) => void
}

export type ModalButtonsProps = {
  nextButton: ButtonProps
  backButton: ButtonProps
}

export type LayoutModalProps<T> = {
  formData: T
  validationSchema: any
  buttonsProps: ModalButtonsProps
  children: React.ReactNode
  formHandler?: (props: FormikProps<Record<string, any>>) => void
}

export function OrganizationLayoutModal({
  formData,
  validationSchema,
  buttonsProps,
  children,
  formHandler,
  ...formikProps
}: LayoutModalProps<OrganizationFormData> & Partial<FormikConfig<FormikValues>>) {
  const { nextButton, backButton } = buttonsProps

  const handleSubmit = useCallback(
    (values: any) => {
      nextButton.onClick(values)
    },
    [nextButton],
  )
  const handleBack = useCallback(
    (values: any) => {
      backButton.onClick(values)
    },
    [backButton],
  )

  return (
    <Formik
      {...formikProps}
      initialValues={formData}
      validationSchema={validationSchema}
      onSubmit={values => handleSubmit(values)}
      validateOnChange
    >
      {formik => {
        formHandler?.(formik)
        const { submitForm, isSubmitting, values } = formik
        return (
          <Form>
            <FormModalScreen
              onBack={() => handleBack(values)}
              onNext={async () => {
                const errors = await formik.validateForm()
                if (Object.keys(errors).length > 0) {
                  formik.setTouched(Object.keys(errors).reduce((acc, key) => ({ ...acc, [key]: true }), {}))
                } else {
                  submitForm()
                }
              }}
              nextText={nextButton.caption}
              backText={backButton.caption}
              disabled={isSubmitting}
            >
              {children}
            </FormModalScreen>
          </Form>
        )
      }}
    </Formik>
  )
}
